import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import en from "./translations/en";
// import de from "./translations/de";

// const storedLang = localStorage.getItem("i18nextLng");

i18n
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		fallbackLng: "en",
		supportedLngs: ["en"],
		detection: {
			// detection order & sources
			order: ["localStorage", "navigator"],
			caches: ["localStorage"], // store selected language
		},
		resources: {
			en,
			// de,
		},
		interpolation: {
			// React already escapes rendered text, so disable i18next's own HTML escaping.
			// Otherwise interpolated values containing & < > " ' (e.g. a list name like
			// "Andreas2's list (6)") get turned into entities such as &#39; and show raw.
			escapeValue: false,
		},
	});

export default i18n;
